export default __webpack_public_path__ + "static/TIMBERLINE-S-SERIES-Nav-Disk-8cf01c5a47c743993e2f44a25cb1e203.png";